import { MAX_STORES } from 'constants/Store';
import StoreListItem from 'components/GlobalModals/InventoryAwareStorePickerModal/StoreListItem';
import ShopYourStoreUtils from 'utils/ShopYourStore';

function StoreList({
    stores, selectedStore, showStoreDetails, selectStore, openModal, pickupInventory, variant
}) {
    const storesToRender = stores.slice(0, MAX_STORES);

    return storesToRender.map((item, index) => {
        const storePickupInventory = ShopYourStoreUtils.getStorePickupInventory(pickupInventory, item.storeId);

        return (
            <StoreListItem
                key={`store_${item.storeId}`}
                item={item}
                index={index}
                selectedStore={selectedStore}
                showStoreDetails={showStoreDetails}
                selectStore={selectStore}
                openModal={openModal}
                storePickupInventory={storePickupInventory}
                variant={variant}
            />
        );
    });
}

export default StoreList;
